export default __webpack_public_path__ + "static/media/undraw_winners_ao2o(1).fb6bf295.svg";